/**
 * Created by rastwe on 3/14/2017.
 */
import {normalize} from '../util/utils';

/**
 * This file represents the initial state in the Redux store.
 * It's used to provide default values in the reducers, in cases
 * where the store doesn't yet have a value, and there are no
 * action matches in the reducer, so that the return value of
 * the reducer function will never be undefined.
 * Use this file to help give you an idea what the overall
 * picture of the Redux store looks like.
 */

const normalizedValue = normalize();
import {
	ExecutiveDashboardButtons,
	TaskCategories,
	TaskStatusIds,
	advancedSearchColumnIds,
	assignmentTypes,
	bulkAssignment,
	collaborationQuickFiltersTabsConstanst,
	gaDocumentStatusFiltersId,
	groupStatusDocumentUIfiltersId,
	groupStatusTaskUIfiltersId,
	sortOrder,
	ViewTypes,
	documentTabLayoutTabs,
	MESTReviewNoteTabs,
	reviewNotesStatus,
	AssignmentStatusType,
	rnhFilterTypeQuery,
	ReviewNoteSubViewTypes,
	modalLevels
} from '../util/uiconstants';

import {labels} from '../util/utils';

export default {
	accountAssertions: [],
	accountDetails: {},
	accountValidationCount: 0,
	accounts: [],
	accountList: [],
	accountsEdit: [],
	activeProjects: {},
	activityFeed: {
		activityList: [],
		document: null,
		instruction: null,
		instructionList: [],
		linkRequest: null,
		linkRequestList: [],
		summary: null
	},
	addclientRequestDocuments: [],
	addDocumentToTask: {},
	apponlinestate: {},
	appVersion: false,
	arcChecksList: {},
	archiveEngagement: {},
	arcValidations: {},
	assertions: {},
	assignments: [],
	associateTaskToggle: 0,
	auditphaseMilestoneDetails: null,
	auditphaseMilestoneDetailsForExecutiveReview: null,
	milestoneDetailsForDashboard: null,
	automationRequest: [],
	automationServiceTimeout: null,
	buildTasks: {},
	bulkAssignmentToasts: [],
	bulkFilter: {},
	bulkFilterData: {},
	bulkquickfilter: null,
	bulkTaskAssignToType: {
		assignmentType: assignmentTypes.preparer,
		selectedTab: bulkAssignment.assign
	},
	bulkTaskListFilters: {
		categoryId: 3,
		currentPage: 1,
		orderByAscending: true,
		pageSize: 20,
		subcategoryId: 1
	},
	bulkTaskSeeTask: new Map(),
	bulkRequestSeeRequest: new Map(),
	bulkRequestSearchOptions: {searchTerm: ''},
	bulkRequestCustomFilter: {},
	bulkRequestSelected: [],
	canEnableAndDisplayMarkCompleteAssignment: null,
	canvasFormChildDocuments: [],
	canvasFormCountries: [],
	canvasFormLanguages: [],
	canvasFormRelatedObjects: {
		allObjects: [],
		selectedObjects: []
	},
	canvasFormRelatedTasks: {
		allTasks: [],
		selectedTasks: []
	},
	canvasFormReport: [],
	canvasFormToSendValidation: [],
	canvasFormTypes: [],
	canvasFormUpdateFilters: {},
	canvasFormUpdates: [],
	changeTaskStatus: {},
	clientFollowersRelatedTasks: {},
	clientRequestAdvancedSearchOptions: {
		options: [],
		searchTerm: ''
	},
	clientRequestAssignedTo: {},
	clientRequestComments: {
		details: {
			comments: [],
			history: []
		},
		modal: {
			comments: [],
			history: []
		}
	},
	clientRequestDetail: {},
	clientRequestDocuments: [],
	clientRequestEYContacts: {},
	clientRequestFilters: {},
	clientRequestRemoveCustomFilterReducer: '',
	clientRequests: {},
	clientRequestsCustomFilter: {
		advancedSearchOptions: {
			options: [
				{
					id: advancedSearchColumnIds.referenceNumber,
					isChecked: false,
					value: labels.advancedSearchRefereceNumberCheck
				},
				{
					id: advancedSearchColumnIds.title,
					isChecked: true,
					value: labels.advancedSearchTitleCheck
				},
				{
					id: advancedSearchColumnIds.documents,
					isChecked: false,
					value: labels.advancedSearchDocumentsCheck
				},
				{
					id: advancedSearchColumnIds.comments,
					isChecked: false,
					value: labels.advancedSearchCommentsCheck
				}
			],
			searchTerm: ''
		}
	},
	/*	clientRequestsCustomFilterOptions: [],*/
	clientRequestSetup: {
		clientEngagementName: {},
		ipFiltering: {}
	},
	clientRequestsSummary: {},
	clientRequestTags: [],
	commonClientReqCustomFilter: {
		isLoaded: false
	},
	commonRNHFilters: {
		isLoaded: false,
		search: ''
	},
	confidentialityTypes: null,
	configurations: {},
	connectivitystate: {},
	contentupdates: {},
	contentUpdateTypes: {},
	controlFormReport: [],
	controls: {},
	copiedDocumentId: null,
	copyhubErrorMessage: '',
	copyhubPackageDetails: {},
	copyhubPackageFileSizes: {
		// evidenceSize: 0.6,
		// tempFilesSize: 9.2,
		// prioPeriodEvidenceSize: 0.0001,
		// recentlyDeletedFilesSize: 0.000001,
		// historyFilesSize: 201.222,
		// eyDocsSize: 22.01,
		// extDocsSize: 10.06
	},
	copyhubPackageList: {},
	copyhubSuccessMessage: '',
	countryStatus: {
		id: 0,
		status: false
	},
	createdEngagementHelixId: null,
	createdTaskDetails: {},
	createdTaskId: null,
	createManualCanvasFormUIState: {
		formTypeId: 0,
		isModalOpen: false,
		successMessage: ''
	},
	createPackageRequest: {
		allItemsToCopy: [],
		categories: {
			hasCanvasForms: false,
			hasEvidence: false,
			hasExternalDocuments: false,
			hasExternalGroupsAndMembers: false,
			hasExternalReqAndTasks: false,
			hasEyDocuments: false,
			hasHistoryFiles: false,
			hasITApplicationSoStructure: false,
			hasPriorPeriodEvidence: false,
			hasRecentlyDeletedFiles: false,
			hasSCOTs: false,
			hasSignOffs: false,
			hasTemporaryFiles: false
		},
		isCopyEngagementInProgress: false,
		packageName: '',
		packageTypeId: 0,
		packageTypeName: '',
		recipients: [],
		selectedList: [],
		selectedPackageTypeIdToCopy: 0
	},
	currentAccountSEM: {},
	dashboardContext: [],
	dashboardTaskDocuments: [],
	deficiencies: [],
	docHelperDocuments: {},
	document: null,
	documentChangeTypes: [],
	documentExtensions: [],
	documentList: {},
	documentName: [],
	documentReviewNoteStatusFilter: {
		value: 0
	},
	documents: [],
	glAccountDocuments: [],
	documentSettingConfiguration: {},
	drillDownEntityDetails: {},
	drillDownTimePhaseDetails: [],
	duplicateDocuments: [],
	glAccountDocUploadCount: 0,
	dynamicList: {
		sortingProps: {}
	},
	engagement: {},
	engagementMap: {},
	engagementAssertions: {},
	engagementAssignments: null,
	engagementITProcesses: [],
	engagementMembers: null,
	engagementMetaData: [],
	engagementProfiles: [],
	engagementPspAccounts: {},
	engagementScots: [],
	engagementTags: [],
	engagementTagGroups: [],
	engagementTagByAccountIds: [],
	engagementTeamMembers: [],
	engagementUsersWithRoles: null,
	epeqrtasksdocsignoffcounts: [],
	errors: {},
	isGlobalErrorToastHidden: false,
	estimates: [],
	events: [],
	executiveDashboard: {
		assignedCount: 0,
		currentUserOrRole: null,
		documentSelectedButton: ExecutiveDashboardButtons.pic,
		isEQRTasksAutoAssigned: false,
		isDocumentNotSignOffBy: false,
		isexpand: true,
		isPICTasksAutoAssigned: false,
		isSelectionReady: false,
		reviewNotesSelectedButton: ExecutiveDashboardButtons.assignedToMe,
		selectedView: ExecutiveDashboardButtons.tasksView,
		taskDrawerCurrentTask: false,
		taskDrawerVisible: false,
		taskSelectedButton: ExecutiveDashboardButtons.currentlyAssigned,
		execute: {
			documentactivetab: documentTabLayoutTabs.evidenceName,
			reviewnoteactivetab: MESTReviewNoteTabs.open,
			collaborationactivetab: collaborationQuickFiltersTabsConstanst.all,
			category: undefined,
			entityuid: undefined,
			view: ViewTypes.tasks,
			tabView: ViewTypes.tableView,
			reviewNoteStatus: reviewNotesStatus.open.label
		},
		myprogress: {
			taskcategoryid: TaskCategories.AllTasks,
			taskactivetab: AssignmentStatusType.current,
			reviewnoteactivetab: MESTReviewNoteTabs.open,
			reviewnoteactivecategory: rnhFilterTypeQuery.assignedTo,
			collaborationactivetab: collaborationQuickFiltersTabsConstanst.all
		},
		alltasks: {},
		allreviewnotes: {
			reviewnoteactivetab: MESTReviewNoteTabs.open,
			reviewnoteactivecategory: ReviewNoteSubViewTypes.showAll
		}
	},
	aiChatBotIntegrationParameters: {},
	multiEntityDashboard: {},
	existingTemporaryDocument: null,
	externalUser: {},
	externalUsers: {},
	filter: {
		isLoaded: false
	},
	filterData: {},
	filterOptions: [
		{
			filterType: 'AssignedTo',
			id: 3,
			values: []
		},
		{
			filterType: 'OpenAssignment',
			id: 4,
			values: []
		},
		{
			filterType: 'ReviewNotesAssignedTo',
			id: 7,
			values: []
		},
		{
			filterType: 'ReviewNotesCreatedBy',
			id: 8,
			values: []
		},
		{
			filterType: 'TimePhase',
			id: 9,
			values: []
		},
		{
			filterType: 'Entity',
			id: 14,
			values: []
		}
	],
	financialStatementsById: {},
	financialStatementsFilters: {},
	formBodyData: [],
	formBodyDisplayData: {},
	formData: {},
	fourFortyGlDocuments: {},
	gaInstructions: null,
	gaLastPublishChange: null,
	GAMLayerWithCountryLanguage: {
		complex: false,
		countryId: -1,
		digital: false,
		groupAudit: false,
		languageId: -1,
		listed: false,
		pcaobfs: false,
		pcaobia: false
	},
	gaScopes: null,
	gaTasks: null,
	gaTeams: {
		components: null,
		linkRequestTeam: null,
		photos: []
	},
	glAccounts: null,
	glAccountNotes: [],
	glNotes: [],
	globalNavState: {},
	globalState: {
		isAutomationHubEnabled: false,
		// here we can put properties which can be used globally
		// By default it is true so we don't trigger a render and then a hide.
		sdmFeatureDisable: true,
		sdmFlagLoaded: false,
		serviceGatewayEnabled: false
	},
	groupAuditComponents: [],
	groupAuditScopes: [],
	groupAuditTasks: {
		fetchPendingEvidence: true
	},
	groupTaskFilter: {
		componentEngagementDocumentFilters: [
			gaDocumentStatusFiltersId.returned,
			gaDocumentStatusFiltersId.notSend,
			gaDocumentStatusFiltersId.draftSend,
			gaDocumentStatusFiltersId.finalSend
		],
		componentEngagementtaskFilters: [
			TaskStatusIds.Open,
			TaskStatusIds.InProgress,
			TaskStatusIds.InReview,
			TaskStatusIds.Complete
		],
		primaryEngagementdocumentFilters: [
			groupStatusDocumentUIfiltersId.received,
			groupStatusDocumentUIfiltersId.prepared,
			groupStatusDocumentUIfiltersId.reviewed,
			groupStatusDocumentUIfiltersId.returned
		],
		primaryEngagementtaskFilters: [
			groupStatusTaskUIfiltersId.documentReceived,
			groupStatusTaskUIfiltersId.documentPending,
			groupStatusTaskUIfiltersId.overdue
		]
	},
	gsScopes: null,
	gsScopesLinkRequest: null,
	gsScopesSendVersion: null,
	gsSnapshots: {
		publishedOptions: null,
		publishedSnapshot: null,
		sentOptions: null,
		sentSnapshot: null,
		sentTeamId: null
	},
	handOffTaskDocuments: {},
	handOffTasks: {},
	handoffUsers: null,
	hasAccessLocation: false,
	helixProjects: {},
	helixProjectFilterMetadata: {},
	helixAnalyzerMaxConnectionReached: null,
	helixMultiEntityImport: {
		data: []
	},
	glAccountStatus: [],
	isValidUserWithProjectAvailable: null,
	mappedEntities: null,
	idleLogout: {
		showPopup: false,
		startLogout: false,
		startTime: null,
		timeoutID: null
	},
	independenceConfirmation: {},
	independenceResponses: {},
	independenceSummary: {},
	instruction: null,
	internalUser: {},
	internalUsers: {},
	irisProjectbyId: [],
	isAssignmentMarkedForCompletion: false,
	isCurrentResourceAvailable: false,
	isDocumentNameAlreadyExists: false,
	isMediaPlaying: false,
	isModalOpen: false,
	isADCModalOpen: false,
	modalLevel: modalLevels.defaultLevel,
	isMultiSelectTasks: false,
	isRegionComponentAssign: false,
	isTaskListGroup: false,
	itApplications: {},
	itApplication: {},
	itControls: [],
	linkedProjects: [],
	liveUpdates: {
		byType: {},
		debounced: {
			byType: {},
			lastUpdated: 0,
			latest: null
		},
		lastUpdated: 0,
		latest: null
	},
	manageAssignments: [],
	manageTeamBehaviour: {
		actionsColVisible: true,
		addEditModalTexts: {
			addAnotherButtonText: '',
			addButtonText: ''
		},
		addThirdPartyMemberButtonVisible: true,
		externalTabVisibile: true,
		independanceColVisible: true,
		mainHeaderText: '',
		postArchiveColVisible: false,
		priorPeriodButtonVisible: false,
		shouldCallValidations: false,
		statusColVisible: true
	},
	markCompleteTasks: {},
	materiality: [],
	mileStone: [],
	milestoneBuildTasks: [],
	misstatements: [],
	multiSelectTasks: [],
	myProgressCollaborationStats: {
		countReadModel: {
			countTotal: 0,
			countDraft: 0,
			countPendingResponse: 0,
			countReceivedByCanvas: 0,
			countAcceptedByCanvas: 0,
			countOverdue: 0
		},
		agingReadModel: []
	},
	myWorkspaces: {},
	newDocumentReviewNote: {},
	newPaperProfileId: null,
	newTaskReviewNote: {},
	offlinePrep: {},
	otherEngagementsReviewNotes: {},
	oversightAllProjects: [],
	oversightotherProjects: [],
	oversightProjects: [],
	overwriteDocuments: {
		documents: [],
		forms: []
	},
	paansuserdata: {},
	piceqrDocumentListFilters: {
		evidences: {
			filters: {
				specific: {
					includePagination: true,
					page: 1,
					pageSize: 20,
					// to override the default filters added because of "related" column config in DocumentView.js of executiveDashboard.
					includeFindings: null,
					includeClientApprovals: null
				}
			},
			response: {
				refresh: true
			}
		}
	},
	piceqrrnhFilters: {
		isLoaded: false,
		search: ''
	},
	picTaskListFilters: {
		categoryId: TaskCategories.AllTasks,
		orderByAscending: true,
		refresh: true,
		subcategoryId: 1
	},
	popUpToastMessage: {},
	priorPeriodUsers: {},
	pspIndexes: [],
	quickAccessDocument: null,
	hasScopeAndStrategyGuidedWorkflow: null,
	quickFilter: {},
	quickLink: {},
	rbacRoles: null,
	receiveIntructions: {
		earlierOptions: null,
		earlierSnapshot: null,
		received: null
	},
	referenceDocuments: {},
	relatedDocuments: [],
	relatedFindings: null,
	relatedRisks: {},
	relatedWCGWs: {
		isLoading: true
	},
	relateRequests: {},
	relateTaskAutomation: null,
	reloadDataBanner: {
		isDrawerOpen: false,
		isReloadRequired: false
	},
	rejectedTask: {},
	acceptedTask: {},
	reportInfo: {},
	reviewAssignments: null,
	reviewNoteCategory: 1,
	reviewNoteDocument: null,
	reviewNotes: {
		notesLoaded: undefined
	},
	reviewNotesAuthoredByCount: {},
	reviewNotesCount: {},
	risks: {},
	riskList: [],
	riskTypes: {},
	riskWcgwSelection: {},
	rnhFilterOptions: [
		{
			filterType: 'reviewnotesauthoredby',
			id: 1,
			values: []
		},
		{
			filterType: 'reviewnotesassignedto',
			id: 2,
			values: []
		}
	],
	rnhFilters: {
		annotationStatusIds: ['1'],
		categoryId: 0,
		currentPage: 1,
		isAscending: true,
		isLoaded: false,
		pageSize: 20,
		quickFilter: 0,
		search: '',
		sortOrder: 0
	},
	rnhIsBulkSelection: false,
	rnhMultipleNotes: [],
	rnhNoteDetail: {
		annotations: null,
		notesModalOpen: false
	},
	rnhNotes: {},
	rnhSelectedNote: {
		entityId: 0,
		noteId: null
	},
	roles: null,
	savedFilters: [],
	scots: {},
	selectedTeams: [],
	serviceLines: [],
	serviceOfferings: [],
	serviceRequest: {
		documents: [],
		dueDate: '',
		id: 0,
		origin: '',
		requestJSON: {
			clientEngagementCode: '',
			clientEngagementName: '',
			cost: '',
			instructionText: ''
		},
		requestName: '',
		returnUrl: null,
		schedulerOfferingId: 0,
		schedulerOfferingName: '',
		selectedEYContacts: [],
		selectedRows: [],
		startDate: '',
		statusId: 0,
		suggestedTasks: [],
		taskList: {},
		tasks: []
	},
	serviceRequestDetail: {},
	serviceRequests: null,
	signOffs: [],
	sortingDetails: {},
	sortTable: {
		[collaborationQuickFiltersTabsConstanst.all]: {
			columnSort: 'PriorityTypeID',
			sortDirection: sortOrder.Desc
		},
		[collaborationQuickFiltersTabsConstanst.draft]: {
			columnSort: 'PriorityTypeID',
			sortDirection: sortOrder.Desc
		},
		[collaborationQuickFiltersTabsConstanst.pending]: {
			columnSort: 'PriorityTypeID',
			sortDirection: sortOrder.Desc
		},
		[collaborationQuickFiltersTabsConstanst.received]: {
			columnSort: 'PriorityTypeID',
			sortDirection: sortOrder.Desc
		},
		[collaborationQuickFiltersTabsConstanst.accepted]: {
			columnSort: 'PriorityTypeID',
			sortDirection: sortOrder.Desc
		}
	},
	statusAssigments: null,
	stentities: [],
	taskstentities: [],
	syncContentUpdates: {},
	syncState: {},
	taskAssignments: null,
	taskCategories: {},
	taskDeleteResponse: '',
	taskDescription: null,
	taskDescriptions: [],
	taskDetails: {
		isEPSignoffRequired: false,
		isEPSignoffUserRequired: false,
		isEQRSignoffRequired: false,
		isEQRSignoffUserRequired: false,
		isTaskGetByIdCallComplated: false,
		resetTaskDetail: undefined
	},
	taskDocumentRelate: null,
	taskDocuments: {},
	taskDocumentSelectedId: '',
	taskDocumentTab: null,
	taskGroupsSections: [],
	taskGuidance: {},
	taskId: null,
	taskList: {},
	taskRelatedUnrelatedEntities: {
		itprocessRelatedTasks: {},
		itprocessUnrelatedTasks: {},
		scotRelatedTasks: {},
		scotUnrelatedTasks: {},
		controlRelatedTasks: {},
		controlUnrelatedTasks: {},
		itcontrolRelatedTasks: {},
		itcontrolUnrelatedTasks: {}
	},
	taskListFilters: {
		assignmentStatus: [0, 1, 2, 3, 4],
		categoryId: 2,
		currentPage: 1,
		orderByAscending: true,
		pageSize: 20,
		subcategoryId: 1,
		taskStatus: [0, 1, 2, 3],
		orderBy: 'duedate',
		searchString: ''
	},
	taskListPreparerCount: {},
	taskListView: {
		collapseLeftPanel: false,
		collapseListPanel: false,
		expandAllPanels: false
	},
	taskRelatedEntities: [],
	taskRelatedItem: {},
	taskRelatedObject: {},
	taskRelatedServiceRequests: {},
	taskReviewNoteStatusFilter: {
		value: 0
	},
	taskServiceOfferings: [],
	taskServiceRequests: null,
	taskSubCategories: [],
	tasksUnassigned: {},
	taskTags: {
		tags: []
	},
	taskWcgws: {
		isLoading: true
	},
	taskSections: [],
	timePhase: {},
	toastMessage: {
		message: '',
		show: false
	},
	toasterDetails: {
		showToaster: false
	},
	userAssignementInformation: {
		isPreparerAssignmentExist: null
	},
	userPreferences: {
		isPreferencesLoaded: false
	},
	userPresence: {},
	userSettings: {},
	validationcounts: [],
	validationdetails: {},
	viewInstructions: [],
	wcgwRelatedRisks: {},
	wcgws: [],
	wcgwDetails: {},
	wcgwTasks: {},
	wcgwTasksScots: {},
	workspaceEngagements: null,
	trialBalances: {...normalizedValue, adjusted: {...normalizedValue}},
	financialStatement: {...normalizedValue},
	knowledgeData: {
		knowledgeIndustries: [],
		knowledgeAccounts: [],
		selectedIndustry: [],
		knowledgeEntityData: [],
		selectedScot: []
	},
	groupInstructions: [],
	validations: []
};
